module.exports = __webpack_public_path__ + "img/3.0d4c6913.jpg";